// import Vue from 'vue'
import { fn } from '@/globals'
import store from '@/store'
let intercomFn = fn.httpsCallable('calls-misc-intercom')

// dispatch intercom error message to user after this amount of errors occurs
let ERROR_COUNT_TRIGGER = 2

// watch error collector
store.watch(state => state.logging.errorsTriggeringIntercom, (newValue, oldValue) => {  

  // console.log('intx', newValue)
  let errorCount = newValue.length
  if (errorCount == ERROR_COUNT_TRIGGER) {
    i.dispatchMessage({
    message: 'isItBroken'
    })
  }
})

let i = {

  context: {
    visitorId: null,
    visitorUserId: null
  },

  // async getVisitorId() {
  //   console.log('intercom: getVisitorId()')
  // 
  //   let visitorId = Vue.prototype.$intercom.getVisitorId()
  //   let uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/
  //   if (!uuidRegex.test(visitorId)) {
  //     console.log('intercom: visitorId is not regex', visitorId)
  //     setTimeout(() => {
  //       this.getVisitorId()
  //     }, 500)
  //   } else {
  //     console.log('intercom: visitorId is already regex')
  //     this.context.visitorId = visitorId
  //     console.log('intercom:', this.context.visitorId)
  // 
  // 
  //     let response = await intercomFn({
  //       action: 'getVisitorUserId',
  //       visitorId: this.context.visitorId
  //     })
  // 
  //     console.log('intercom: visitorUserId:', response.data.visitorUserId)
  //     this.context.visitorUserId = response.data.visitorUserId
  // 
  //   }
  // },

  async dispatchMessage(args) {
    console.log('intercom: dispatchMessage()')
    let response = await intercomFn({
      action: 'dispatchMessage',
      userId: this.context.visitorUserId,
      message: args.message,
      lang: 'cs'
    })
    
    console.log('intercom: response:', response.data)
  }
}

export const Intercom = i